import { Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { FcViewDetails } from 'react-icons/fc';
import { IoMdNotifications } from 'react-icons/io';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { Row } from 'reactstrap';
import Toast from '../../helpers/Toast';
import { RemindersFromMaintenancePlanRequestDTO } from '../../models/Reminders/RemindersFromMaintenancePlanRequestDTO';
import { RemindersFromMaintenancePlanResponseDTO } from '../../models/Reminders/RemindersFromMaintenancePlanResponseDTO';
import { ReminderService } from '../../services/ReminderService';
import ButtonComponent from '../ButtonComponent';
import TableComponent from '../TableComponent';
import CancelReminderComponent from './CancelReminderComponent';
import EditReminderComponent from './EditReminderComponent';
import Routes from '../../helpers/Routes';

type RemindersFromMaintenancePlanProps = {
    maintenancePlanId: string | null,
}

function RemindersFromMaintenancePlan(props: RemindersFromMaintenancePlanProps) {

    const reminderService = new ReminderService();
    const intl = useIntl();
    const [reminders, setReminders] = useState<RemindersFromMaintenancePlanResponseDTO[]>([]);

    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);

    const [isButtonCreateRemindersLoading, setIsButtonCreateRemindersLoading] = useState<boolean>(false);

    // popup
    const [isEditReminderOpen, setIsEditReminderOpen] = useState<boolean>(false);
    const [currentReminder, setCurrentReminder] = useState<RemindersFromMaintenancePlanResponseDTO | null>(null);
    const [isCancelReminderOpen, setIsCancelReminderOpen] = useState<boolean>(false);

    // Detalhes Lembrete
    const navigate = useNavigate();


    const columns = React.useMemo(
        () => [
            {
                Header: "",
                accessor: " ",
                width: 5,
                Cell: (props: any) => {
                    const alert = props.cell.row.original.alert;
                    return (
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <Tooltip
                                title="Ver Detalhes"
                                aria-label="Ver Detalhes"
                                enterNextDelay={500}
                                enterDelay={500}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        flexDirection: "column",
                                        cursor: "pointer"
                                    }}
                                    onClick={() => {
                                        const reminderId = props.cell.row.original.reminderId || null;
                                        ReminderDetailsNavigation(reminderId);
                                    }}
                                >
                                    <FcViewDetails className="icons" />
                                </div>
                            </Tooltip>
                            {alert != null &&
                                <Tooltip title={`Alerta: ${alert}`} aria-label={alert} enterNextDelay={500} enterDelay={500}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            color: "red",
                                            fontSize: "24px"
                                        }}
                                    >
                                        <IoMdNotifications />
                                    </div>
                                </Tooltip>
                            }
                        </div>
                    );
                }
            },
            {
                Header: "Data",
                accessor: "reminderDate",
                width: 15,
            },
            {
                Header: "Dia da Semana",
                accessor: "reminderDayOfWeek",
                width: 15,
            },
            {
                Header: "Alterar Data",
                accessor: "  ",
                Cell: (props: any) => {
                    const isCancelled = props.cell.row.original.isCancelled;

                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;
                    return (
                        <div style={{ display: "inline-flex", height: "30px" }}>
                            <ButtonComponent
                                text={intl.formatMessage({ id: "Screens.RemindersFromMaintenancePlans.UpdateReminderDate" })}
                                disabled={isLoading || isCancelled || isConvertedIntoAssistance}
                                onClick={() => UpdateReminderDate(props.cell.row.original)}
                            />
                        </div>
                    );
                },
                width: 20,
            },
            {
                Header: "Cancelar",
                accessor: "   ",
                Cell: (props: any) => {
                    const isCancelled = props.cell.row.original.isCancelled;
                    const reminderCurrentStatus = props.cell.row.original.reminderCurrentStatus;

                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;
                    return (
                        <div style={{ display: "inline-flex", height: "30px" }}>
                            {isCancelled ? (
                                <div style={{ display: "inline-flex", height: "30px", justifyContent: "center", alignItems: "center" }}>{reminderCurrentStatus}</div>
                            ) : (
                                <ButtonComponent
                                    text={intl.formatMessage({ id: "Screens.RemindersFromMaintenancePlans.CancelReminder" })}
                                    disabled={isLoading || isConvertedIntoAssistance}
                                    onClick={() => CancelReminder(props.cell.row.original)}
                                />
                            )}
                        </div>
                    );
                },
                width: 20,
            },
            {
                Header: "Pedido",
                accessor: "    ",
                Cell: (props: any) => {
                    const assistanceNumber = props.cell.row.original.assistanceNumber;
                    const isConvertedIntoAssistance = assistanceNumber !== "" && assistanceNumber !== null && assistanceNumber !== undefined;

                    const isCancelled = props.cell.row.original.isCancelled;
                    return (
                        <>
                            {isConvertedIntoAssistance ? (
                                assistanceNumber
                            ) : (
                                <div style={{ display: "inline-flex", height: "30px" }}>
                                    <ButtonComponent
                                        text={intl.formatMessage({ id: "Screens.RemindersFromMaintenancePlans.CreatePAT" })}
                                        disabled={isLoading || isCancelled}
                                        onClick={() => ConvertMaintenanceToAssistance(props.cell.row.original.reminderId)}
                                    />
                                </div>
                            )}
                        </>
                    );
                },
                width: 25,
            },
        ],
        [],
    );

    const ConvertMaintenanceToAssistance = async (reminderId: number | null) => {
        setIsLoading(true);

        var response = await reminderService.ConvertMaintenanceToAssistance(reminderId);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        Toast.Show("success", response.message);
        setIsLoading(false);

        GetReminders(currentPage ?? 1, pageSize ?? 5);
    }

    const GetReminders = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data: RemindersFromMaintenancePlanRequestDTO = {
            maintenancePlanId: Number(props.maintenancePlanId) ?? null,
            currentPage: currentPage,
            pageSize: pageSize,
        }

        var response = await reminderService.GetRemindersFromMaintenancePlan(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        setReminders(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    const CreateReminders = async (maintenancePlanId: number) => {
        setIsButtonCreateRemindersLoading(true);
        var response = await reminderService.CreateAutomaticReminders(maintenancePlanId);
        if (response.success === false) {
            setIsButtonCreateRemindersLoading(false);
            Toast.Show("error", response.message);
            return;
        }
        setIsButtonCreateRemindersLoading(false);
        Toast.Show("success", response.message);

        GetReminders(currentPage ?? 1, pageSize ?? 5);
    };


    // Popup alterar data do lembrete
    const UpdateReminderDate = (reminder: RemindersFromMaintenancePlanResponseDTO) => {
        setCurrentReminder(reminder);
        setIsEditReminderOpen(true);
    };
    const handleEditReminder = (data: RemindersFromMaintenancePlanResponseDTO | null) => {
        setIsEditReminderOpen(false);
    };
    const handleCloseEdit = () => {
        setIsEditReminderOpen(false);
    };

    // Popup cancelar lembrete
    const CancelReminder = (reminder: RemindersFromMaintenancePlanResponseDTO) => {
        setCurrentReminder(reminder);
        setIsCancelReminderOpen(true);
    };
    const handleCancelReminder = (data: RemindersFromMaintenancePlanResponseDTO | null) => {
        setIsCancelReminderOpen(false);
    };
    const closeReminderComponent = () => {
        setIsCancelReminderOpen(false);
    };


    useEffect(() => {
        if (props.maintenancePlanId !== "" || props.maintenancePlanId !== null || props.maintenancePlanId !== undefined) {
            GetReminders(currentPage ?? 1, pageSize ?? 5)
        }
    }, [props.maintenancePlanId, currentPage, pageSize, isEditReminderOpen, isCancelReminderOpen])

    //navegar para detalhes lembrete
    const ReminderDetailsNavigation = async (reminderId: number | null) => {
        navigate(`${Routes.reminders.details}/${reminderId}`);
    }
    return (
        <div>
            <label style={{ margin: "0px" }}></label>

            <Row>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.RemindersFromMaintenancePlans.CreateReminders" })}
                    onClick={() => CreateReminders(Number(props.maintenancePlanId) ?? null)}
                    xs={12} //--» isto tmb não afeta muito, apenas remover o "esticar maximo" com dentro da row... mas já é bem mais personalizavel do que o botão com versão antiga...
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    // marginCol={{ marginTop: "25px", marginBottom: "20px" }} // --» Mateus alterou mas o marginCol não é necessário para nada, style chega e sobra
                    style={{ minHeight: "37px", minWidth: "100px", marginTop: "25px", marginBottom: "25px" }}
                />
            </Row>
            {/* APENAS DEPOIS DE GERAR LEMBRETES OU SE LEMBRETES TIVEREM VALOR PARA SER MOSTRADO, UMA VEZ QUE FORAM GERADOS ANTERIORMENTE */}

            {reminders.length > 0 && (
                <TableComponent
                    columns={columns}
                    data={reminders}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetReminders}
                    initialSortBy={[]}
                    disableSortBy={true}
                />
            )}

            {isEditReminderOpen && (
                <EditReminderComponent
                    IsOpen={isEditReminderOpen}
                    Edit={handleEditReminder}
                    CurrentReminder={currentReminder}
                    SetCurrentReminder={setCurrentReminder}
                    OnClose={handleCloseEdit}
                />
            )}

            {isCancelReminderOpen && (
                <CancelReminderComponent
                    IsOpen={isCancelReminderOpen}
                    Cancel={handleCancelReminder}
                    CurrentReminder={currentReminder}
                    SetCurrentReminder={setCurrentReminder}
                    OnClose={closeReminderComponent}
                />
            )}
        </div>
    )
}

export default RemindersFromMaintenancePlan